import hooks from './shipment-tracking.hooks';

export default (app) => {
  const service = app.service('api/shipment-tracking');
  service.hooks(hooks);
};
